export interface IModel {
  id?: number | string;
}
